@if (canDisplay()) {
  <div id="stats-menus-egalim" class="card mg-b-10 card-size">
    <div class="card-header">
      <div class="d-flex">
        <div class="flex-grow-1">
          <span class="mg-r-5">Analyse Egalim pour la prestation</span>
          <strong>{{ mp2Svc?.planningMenus?.contratMenuConviveList[0]?.contratMenuLibelle }}
            - {{ mp2Svc?.planningMenus?.contratMenuConviveList[0]?.libelle }} (Unité de production {{ udp }}) </strong>
        </div>

        <div class="mg-r-5">
          <yo-commande-fournisseur-date-filter
            (onValueChange)="onDateFilterValueChange($event)"
            height="45px"
            [selectedDates]="selectedPeriode"
          >
          </yo-commande-fournisseur-date-filter>
        </div>
      </div>
    </div>
    <div class="card-body">
      @if (!dataGraphic()) {
        <p>Veuillez sélectionner une période et saisir un effectif</p>
      } @else if (hasErrors()) {
        <div class="alert alert-warning">
          Le calcul EGAlim n'a pas pu être réalisé. Veuillez corriger les erreurs ci-dessous :
        </div>

        @if (appellationSansOrdreList().length) {
          <div class="font-weight-bold mg-b-5">Appellations sans ordre</div>
          <dx-data-grid
            class="mg-b-15"
            [dataSource]="appellationSansOrdreList()"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [rowAlternationEnabled]="true"
            [wordWrapEnabled]="true">
            <dxi-column dataField="appellationLibelle" caption="Appellation"></dxi-column>
          </dx-data-grid>
        }

        @if (produitSansFamilleList().length) {
          <div class="font-weight-bold mg-b-5">Produits sans famille EGAlim</div>
          <dx-data-grid
            [dataSource]="produitSansFamilleList()"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [rowAlternationEnabled]="true"
            [wordWrapEnabled]="true">
            <dxi-column dataField="produitDeclineCode" caption="Code produit décliné"></dxi-column>
            <dxi-column dataField="produitDeclineLibelle" caption="Libellé produit décliné"></dxi-column>
          </dx-data-grid>
        }
      } @else {
        <yo-indicateur-egalim
          [values]="[dataGraphic().pourcentageDurable, dataGraphic().pourcentageBio, dataGraphic().pourcentageMontantProduitsPoissonViande]"
          [inputSeuils]="seuils"
          [isConformeEgalim]="dataGraphic().egalim"
          [subtitle]="getPeriod() + '<br>' +udp"
          [titleText]="customizeTextLabel"
          [tooltipText]="customizeTooltip"
          [legendText]="customizeText"
          (onChangeSeuil)="changeSeuil($event)">
        </yo-indicateur-egalim>
      }
    </div>

  </div>
}
